import { Trans } from 'lingui-react';
import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment-timezone';

import { FormattedRelative } from 'decisiv-domain-utils';

import Widget from 'elements/Widget';
import Table from 'elements/Table';
import Span from 'elements/Span';
import BorderedStatus from 'elements/BorderedStatus';

import { formatDate, userTimeZone } from 'utils/timeUtils';
import { getOutputText } from 'utils/widget';

import messages from './messages';
import withConnectedData from './Container';

export function CaseStatusWidget({ caseInfo }) {
  const { closedAt, etr, repairStatus, requestedAt } = caseInfo;

  const openOrClosed = closedAt ? 'closed' : 'open';
  const formattedEtr = etr ? formatDate(etr) : getOutputText(null);

  const createdAt = requestedAt && (
    <FormattedRelative
      render={relativeTime => (
        <Span modifiers={['capitalize']}>{relativeTime}</Span>
      )}
      value={moment.tz(requestedAt, userTimeZone())}
    />
  );

  return (
    <Widget expandKey="case-status">
      <Widget.Header>
        <Trans id={messages.title} />
      </Widget.Header>
      <Widget.Item>
        <Widget.SubHeader>
          <BorderedStatus modifiers={[openOrClosed]}>
            {openOrClosed}
          </BorderedStatus>
        </Widget.SubHeader>
      </Widget.Item>
      <Widget.Item>
        <Table modifiers={['smallText']} trModifiers={['flex', 'wide']}>
          <tbody>
            <tr>
              <th>
                <Trans id={messages.repairStatus} />
              </th>
              <td>{getOutputText(repairStatus)}</td>
              <th>
                <Trans id={messages.etr} />
              </th>
              <td>{formattedEtr}</td>
              <th>
                <Trans id={messages.created} />
              </th>
              <td>
                {getOutputText(createdAt)}
              </td>
            </tr>
          </tbody>
        </Table>
      </Widget.Item>
    </Widget>
  );
}

CaseStatusWidget.propTypes = {
  caseInfo: PropTypes.shape({
    closedAt: PropTypes.string,
    repairStatus: PropTypes.string,
    etr: PropTypes.string,
    downtime: PropTypes.string,
  }).isRequired,
};

export default withConnectedData(CaseStatusWidget);



// WEBPACK FOOTER //
// ./compositions/CaseStatusWidget/index.js